module.exports = __webpack_public_path__ + "static/media/500.990ae4d0.svg";